import { render } from "./CsvImport.vue?vue&type=template&id=5822f287&scoped=true&ts=true"
import script from "./CsvImport.vue?vue&type=script&lang=ts"
export * from "./CsvImport.vue?vue&type=script&lang=ts"

import "./CsvImport.vue?vue&type=style&index=0&id=5822f287&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5822f287"]])

export default __exports__